var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"filter-button",class:{ active: _vm.selected },attrs:{"aria-label":_vm.ariaLabel},on:{"click":_vm.handleClick}},[_vm._v("\n\t"+_vm._s(_vm.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }